import React, { createContext, useState, useEffect } from "react";
import fetchGlossary from "../methods/api/fetchGlossary";

export const GlossaryContext = createContext();

export const GlossaryProvider = ({ children }) => {
  const [glossary, setGlossary] = useState([]);

  useEffect(() => {
    fetchGlossary().then((data) => {
      setGlossary(data);
    });
  }, []);

  return (
    <GlossaryContext.Provider value={glossary}>
      {children}
    </GlossaryContext.Provider>
  );
};
